import { put, takeLatest } from "redux-saga/effects";
import { call } from "redux-saga/effects";
import searchEngineers from "sc/backend/oncall/partners/cities/list-regions";
import {
  ENGINEER_SEARCH_NEEDLE_CHANGED,
  engineerSearchResultsLoaded,
} from "../actions/engineers";
import { showErrorPage } from "../../../../actions/ui/location";

const engineerSearchNeedleChangedSaga = function*(action) {
  try {
    const result = yield call(searchEngineers, action.payload.cityId);
    yield put(engineerSearchResultsLoaded(result.regions));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(
    ENGINEER_SEARCH_NEEDLE_CHANGED,
    engineerSearchNeedleChangedSaga,
  );
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineer-search-needle-changed.js